<p class="modal-subtitle">{{ 'aumico_notes_super_table_add_column_menu_sub_title' | i18next }}</p>
<ul class="selection-list">
    <li (click)="selectOption(superTableAddColumn.FREE_COLUMN)" class="selection-item">
        {{ 'aumico_notes_super_table_add_column_menu_option_add_column' | i18next }}
    </li>

    <li (click)="selectOption(superTableAddColumn.CALCULATION)" class="selection-item" data-testid="super-table-add-column-calculation">
        {{ 'aumico_notes_super_table_add_column_menu_option_add_calculation' | i18next }}
    </li>
</ul>
